// src/lib/composables/useBookingLinkRoute.ts
import { computed } from 'vue';
import { useRoute } from 'vue-router';

/** Route name → the path segment underneath `/appointment-booking/:bookingLinkId`. */
const STEP_SEGMENTS: Record<string, string> = {
  'appointment-booking-patient-details': 'patient-details',
  'appointment-booking-reason-for-appointment': 'reason-for-appointment',
  'appointment-booking-choose-appointment': 'choose-appointment',
  'appointment-booking-booked-successfully': 'booked-successfully',
};

// Steps are pushed by path: `patchTenantAwarePush` prefixes the tenant onto a
// path, while the store's chain speaks route names. Reconciled here.
export function useBookingLinkRoute() {
  const route = useRoute();

  const bookingLinkId = computed(() => (route.params.bookingLinkId as string | undefined) ?? null);

  const pathForStep = (stepName: string) =>
    `/appointment-booking/${bookingLinkId.value}/${STEP_SEGMENTS[stepName] ?? ''}`;

  return { bookingLinkId, pathForStep };
}
